import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["id", "data-kt-drawer-name", "data-kt-drawer-width", "data-kt-drawer-toggle"]
const _hoisted_2 = { class: "card shadow-none rounded-0 w-100" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-title fw-semobold text-gray-600 position-relative pe-6" }
const _hoisted_5 = {
  key: 0,
  class: "position-absolute top-50 end-0 translate-middle-y lh-0 me-1"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = {
  key: 0,
  class: "card-footer"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_13 = { key: 1 }

import { DrawerComponent } from "@/assets/ts/components";
import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiderDetail',
  props: {
  title: { type: String, required: true },
  submited: { type: Boolean, required: true },
  isLoading: { type: Boolean, required: true },
  save: { type: Function, required: true },
  saveTitle: String,
  savingTitle: String,
  discardTitle: String,
  discard: { type: Function, required: true },
  elId: { type: String, required: true },
  width: String,
  isDisabled: Boolean,
  showFooter: { type: Boolean, required: false, default: true },
},
  setup(__props, { expose: __expose }) {

const props = __props;



const siderDetailRef = ref<Node>();

onMounted(() => {
  document.body.appendChild(siderDetailRef.value as Node);
});

const show = () => {
  // console.log("has: ", DrawerComponent.hasInstace(props.elId));
  let d = null;
  if (DrawerComponent.hasInstace(props.elId)) {
    d = DrawerComponent.getInstance(props.elId);
  } else {
    d = DrawerComponent.createInstances(props.elId);
  }
  d.show();
};

const hide = () => {
  const d = DrawerComponent.getInstance(props.elId);
  d.hide();
};
__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: props.elId,
    class: "bg-body",
    "data-kt-drawer": "true",
    "data-kt-drawer-name": props.elId,
    "data-kt-drawer-activate": "true",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": 
      props.width ? props.width : '{default:\'80%\', \'md\': \'60%\'}'
    ,
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": '#' + props.elId + '_toggle',
    "data-kt-drawer-close": "#sider_detail_close",
    ref_key: "siderDetailRef",
    ref: siderDetailRef
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, [
          _createTextVNode(_toDisplayString(props.title) + " ", 1),
          (props.isLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (__props.showFooter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("button", {
              id: "sider_detail_close",
              class: "btn btn-light me-3",
              type: "reset",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.discard && props.discard(...args)))
            }, _toDisplayString(props.discardTitle ? props.discardTitle : _ctx.$t("action.discard")), 1),
            _createElementVNode("button", {
              id: "role_show_submit",
              class: "btn btn-primary",
              type: "submit",
              disabled: props.submited || props.isLoading || props.isDisabled,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (props.save && props.save(...args)))
            }, [
              (props.submited)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createTextVNode(_toDisplayString(props.savingTitle ? props.savingTitle : _ctx.$t("action.saving")) + " ", 1),
                    _hoisted_12
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(props.saveTitle ? props.saveTitle : _ctx.$t("action.save")), 1))
            ], 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}
}

})